import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { toPayload } from '../../core/helpers/rx-pipes';
import { AccountService } from '../services/account.service';
import * as account from '../actions/account';
import * as auth from '../actions/auth.actions';
import * as status from '../../base/actions/status.actions';
var AccountEffects = /** @class */ (function () {
    function AccountEffects(actions$, store, accountService, router) {
        var _this = this;
        this.actions$ = actions$;
        this.store = store;
        this.accountService = accountService;
        this.router = router;
        this.startCreate$ = this.actions$
            .pipe(ofType(account.CREATE), toPayload(), switchMap(function (payload) {
            return _this.accountService.createAccount(payload)
                .pipe(map(function (result) { return new account.CreateSuccess(tslib_1.__assign({}, result, { password: payload.password })); }), catchError(function (e) { return of(new account.CreateFailed(e)); }));
        }));
        this.successfulCreation$ = this.actions$
            .pipe(ofType((account.CREATE_SUCCESS)), toPayload(), tap(function (response) {
            _this.store.dispatch(new status.SetHeader(true));
            if (response.emailVerified && response.validated) {
                _this.store.dispatch(new auth.Login(response));
            }
            else {
                _this.router.navigate(['create-account', 'success']);
            }
        }));
        this.startForgot$ = this.actions$.ofType(account.FORGOT)
            .pipe(toPayload(), switchMap(function (request) {
            return _this.accountService.initForgot(request)
                .pipe(map(function (result) { return new account.ForgotSuccess(); }), catchError(function (e) { return of(new account.ForgotFailed(e)); }));
        }));
        this.startReset$ = this.actions$.ofType(account.RESET)
            .pipe(toPayload(), switchMap(function (request) {
            return _this.accountService.resetPassword(request.token, request.password)
                .pipe(map(function (result) { return new account.ResetSuccess(); }), catchError(function (e) { return of(new account.ResetFailed(e)); }));
        }));
        this.activateAccount = this.actions$.ofType(account.ACTIVATE)
            .pipe(toPayload(), switchMap(function (token) {
            return _this.accountService.activateAccount(token)
                .pipe(map(function () { return new account.ActivateSuccess(); }), catchError(function (e) { return of(new account.ActivateFailed(e)); }));
        }));
        this.validatePasswordResetLink$ = this.actions$.pipe(ofType(account.VALIDATE_RESET_LINK), switchMap(function (action) {
            return _this.accountService.validateResetPassordLink(action.payload)
                .pipe(map(function (linkValid) { return new account.ValidateResetLinkSuccess(linkValid); }), catchError(function (e) { return of(new account.ValidateResetLinkFailed(e)); }));
        }));
        this.userGetLanguage$ = this.actions$.pipe(ofType(account.USER_GET_LANGUAGE), switchMap(function (action) {
            return _this.accountService.getUserLanguage(action.payload)
                .pipe(map(function (language) { return new account.UserGetLanguageSuccess(language); }), catchError(function (e) { return of(new account.UserGetLanguageFailed(e)); }));
        }));
        this.verifyEmailAddress$ = this.actions$.pipe(ofType(account.USER_VERIFY_EMAIL), switchMap(function (action) {
            return _this.accountService.verifyEmail(action.payload)
                .pipe(map(function (result) { return new account.UserVerifyEmailSuccess(result); }), catchError(function (e) { return of(new account.UserVerifyEmailFailed(e)); }));
        }));
        this.successForgot$ = this.actions$.ofType(account.FORGOT_SUCCESS)
            .pipe(tap(function () { return _this.router.navigate(['reset-account', 'success']); }));
        this.successReset$ = this.actions$.ofType(account.RESET_SUCCESS)
            .pipe(tap(function () { return _this.router.navigate(['reset-password', 'success']); }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], AccountEffects.prototype, "startCreate$", void 0);
    tslib_1.__decorate([
        Effect({ dispatch: false }),
        tslib_1.__metadata("design:type", Observable)
    ], AccountEffects.prototype, "successfulCreation$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], AccountEffects.prototype, "startForgot$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], AccountEffects.prototype, "startReset$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], AccountEffects.prototype, "activateAccount", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], AccountEffects.prototype, "validatePasswordResetLink$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], AccountEffects.prototype, "userGetLanguage$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], AccountEffects.prototype, "verifyEmailAddress$", void 0);
    tslib_1.__decorate([
        Effect({ dispatch: false }),
        tslib_1.__metadata("design:type", Observable)
    ], AccountEffects.prototype, "successForgot$", void 0);
    tslib_1.__decorate([
        Effect({ dispatch: false }),
        tslib_1.__metadata("design:type", Observable)
    ], AccountEffects.prototype, "successReset$", void 0);
    return AccountEffects;
}());
export { AccountEffects };
